import { MaterialIcon } from "@website/icons/material";
import { useInput } from "@website/ui/datepicker/components/input/input.hook";
import styles from "@website/ui/datepicker/components/input/input.module.scss";
import { InputPropertiesType } from "@website/ui/datepicker/components/input/input.types";
import { TextField } from "@website/ui/text-field";
import { FC, memo } from "react";

const Input: FC<InputPropertiesType> = (properties) => {
  const {
    mode,
    fullWidth,
    helperText,
    error,
    changeableMode,
    size = "default",
    inputClassName,
    hideMiddleLine,
    labelClassName
  } = properties;
  const {
    rootProps,
    startTextFieldProperties,
    endEnableButtonProperties,
    endTextFieldProperties,
    endEnableButtonText
  } = useInput(properties);

  return (
    <div
      {...rootProps}
      className={`${styles["input"]} ${fullWidth ? styles["full-width"] : ""} ${
        error ? styles["error"] : ""
      }`}
    >
      <div className={styles["inputs-container"]}>
        <div className={styles["text-field-container"]}>
          <TextField
            {...startTextFieldProperties}
            inputClassName={inputClassName}
            labelClassName={labelClassName}
          />
        </div>
        {mode === "single" ? (
          changeableMode ? (
            <>
              <div
                className={`${styles["middle"]} ${
                  size === "dense"
                    ? styles["middle__dense"]
                    : styles["middle__default"]
                }`}
              >
                <div className={styles["middle-line"]} />
              </div>
              <button
                className={styles["enable-second-mode-button"]}
                {...endEnableButtonProperties}
              >
                {endEnableButtonText}
                <MaterialIcon name="add" variant="outlined" />
              </button>
            </>
          ) : null
        ) : (
          <>
            {!hideMiddleLine && (
              <div className={styles["middle"]}>
                <div className={styles["middle-line"]} />
              </div>
            )}

            <div className={styles["text-field-container"]}>
              <TextField
                {...endTextFieldProperties}
                inputClassName={inputClassName}
                labelClassName={labelClassName}
              />
            </div>
          </>
        )}
      </div>
      {helperText ? (
        <div className={styles["helper-text"]}>{helperText}</div>
      ) : null}
    </div>
  );
};

const InputMemoized = memo(Input);
export { InputMemoized as Input };
